var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root d-flex flex-column h-100", class: _vm.theme },
    [
      _c("div", { staticClass: "case-header" }, [
        _c("h6", { staticClass: "case-title mb-0" }, [
          _vm._v(_vm._s(_vm.T.wordsCases)),
        ]),
      ]),
      _c("div", { staticClass: "summary" }, [
        _vm._v(" " + _vm._s(_vm.summary) + " "),
      ]),
      _c(
        "form",
        {
          staticClass: "case-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.createCase()
            },
          },
        },
        [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newCaseWeight,
                  expression: "newCaseWeight",
                },
              ],
              staticClass: "form-control case-weight",
              attrs: {
                type: "number",
                placeholder: _vm.T.caseSelectorCaseWeight,
              },
              domProps: { value: _vm.newCaseWeight },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newCaseWeight = $event.target.value
                },
              },
            }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newCaseName,
                  expression: "newCaseName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                "data-case-name": "",
                placeholder: _vm.T.caseSelectorCaseName,
              },
              domProps: { value: _vm.newCaseName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.newCaseName = $event.target.value
                },
              },
            }),
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn-sm text-nowrap w-100 mt-2",
              class: {
                "btn-primary": _vm.theme == "vs",
                "btn-secondary": _vm.theme == "vs-dark",
              },
              attrs: {
                type: "submit",
                disabled: !_vm.newCaseName.length,
                "data-add-button": "",
              },
            },
            [_vm._v(" " + _vm._s(_vm.T.caseSelectorAddCase) + " ")]
          ),
        ]
      ),
      _c("div", { staticClass: "filenames" }, [
        _c(
          "div",
          { staticClass: "list-group" },
          [
            !_vm.groups
              ? _c(
                  "button",
                  {
                    staticClass:
                      "list-group-item list-group-item-action disabled",
                    attrs: { type: "button" },
                  },
                  [_c("em", [_vm._v(_vm._s(_vm.T.wordsEmpty))])]
                )
              : _vm._l(_vm.groups, function (group) {
                  return [
                    group.explicit
                      ? _c(
                          "div",
                          {
                            key: group.name,
                            staticClass:
                              "list-group-item list-group-item-secondary",
                          },
                          [
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "verdict",
                                  class: _vm.verdictClass(
                                    _vm.groupResult(group.name)
                                  ),
                                  attrs: {
                                    title: _vm.verdictTooltip(
                                      _vm.groupResult(group.name)
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.verdictLabel(
                                        _vm.groupResult(group.name)
                                      )
                                    )
                                  ),
                                  _c("span", { staticClass: "score" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.score(_vm.groupResult(group.name))
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _c("span", { attrs: { title: group.name } }, [
                                _vm._v(_vm._s(group.name)),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                    _vm._l(group.cases, function (item) {
                      return _c(
                        "button",
                        {
                          key: item.name,
                          staticClass:
                            "list-group-item list-group-item-action d-flex justify-content-between align-items-center",
                          class: {
                            "in-group": group.explicit,
                            active: _vm.currentCase == item.name,
                          },
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.selectCase(item.name)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "text-truncate" }, [
                            _c(
                              "span",
                              {
                                staticClass: "verdict",
                                attrs: {
                                  title: _vm.verdictTooltip(
                                    _vm.caseResult(item.name)
                                  ),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.verdictLabel(_vm.caseResult(item.name))
                                  )
                                ),
                                _c("span", { staticClass: "score" }, [
                                  _vm._v(
                                    _vm._s(_vm.score(_vm.caseResult(item.name)))
                                  ),
                                ]),
                              ]
                            ),
                            _c("span", { attrs: { title: item.name } }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]),
                          _vm.groups.length > 1
                            ? _c(
                                "button",
                                {
                                  staticClass: "close",
                                  attrs: {
                                    "aria-label": _vm.T.wordsClose,
                                    type: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      $event.stopPropagation()
                                      return _vm.removeCase(item.name)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { "aria-hidden": "true" } },
                                    [_vm._v("×")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    }),
                  ]
                }),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }